import { useState } from 'react';
import { apiNode } from '../../../../services/api';
import { ButtonsContainer, Container, Content } from './styles';

import defaultImg from '../../../../assets/img/not-found-image.png';

import { SyncOutlined } from '@ant-design/icons';
import { AiOutlineClose, AiOutlineCheck } from 'react-icons/ai';

interface InviteProps {
  id: number;
  liga: {
    id: number;
    nome: string;
    privada: boolean;
  };
}

interface CardProps {
  invite: InviteProps;
  openSuccessModal: (invite: InviteProps) => void;
  updateInvitesList: (id: number) => void;
}

export const Card: React.FC<CardProps> = ({
  invite,
  openSuccessModal,
  updateInvitesList,
}: CardProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const [isAcceptButtonLoading, setIsAcceptButtonLoading] = useState(false);
  const [isDeclineButtonLoading, setIsDeclineButtonLoading] = useState(false);

  const handleAcceptInviteLeague = async () => {
    try {
      setIsLoading(true);
      setIsAcceptButtonLoading(true);

      await apiNode.post(`/convites/aceitar`, {
        conviteId: invite.id,
      });

      openSuccessModal(invite);
      setIsLoading(false);
      setIsAcceptButtonLoading(false);
    } catch (err) {
      console.log(err);
      setIsLoading(false);
      setIsAcceptButtonLoading(false);
    }
  };

  const handleDeclineInviteLeague = async () => {
    try {
      setIsLoading(true);
      setIsDeclineButtonLoading(true);

      await apiNode.post(`/convites/recusar/`, {
        conviteId: invite.id,
      });

      updateInvitesList(invite.id);
      setIsLoading(false);
      setIsDeclineButtonLoading(false);
    } catch (err) {
      console.log(err);
      setIsLoading(false);
      setIsDeclineButtonLoading(false);
    }
  };

  return (
    <Container>
      <Content>
        <span>
          <img src={defaultImg} alt={`Foto de ${invite.liga.nome}`} />
        </span>

        <div>
          <span>
            <h1>{invite.liga.nome}</h1>
          </span>
        </div>

        <ButtonsContainer>
          <button
            type="button"
            {...(!isLoading && { onClick: handleAcceptInviteLeague })}
          >
            {isAcceptButtonLoading ? <SyncOutlined spin /> : <AiOutlineCheck />}
          </button>
          <button
            type="button"
            {...(!isLoading && { onClick: handleDeclineInviteLeague })}
          >
            {isDeclineButtonLoading ? (
              <SyncOutlined spin color="red" />
            ) : (
              <AiOutlineClose />
            )}
          </button>
        </ButtonsContainer>
      </Content>
    </Container>
  );
};
